import React, { useContext, useEffect, useState } from "react";

import { GeographyType } from "models/Geography";
import { useLocation } from "react-router-dom";
import FormsLibrarySearch from "../../shared/forms/library/FormsLibrarySearch";
import { AtticusForm } from "models/AtticusForm";
import { QueryPayload } from "apis/FormsAPI";
import { formsApi } from "apis";
import { Box } from "@mui/material";
import { FormsList } from "../../shared/forms/list/FormsList";
import { FormsListZeroState } from "../../shared/forms/list/FormsListZeroState";
import { useAuthContext } from "AuthContextWrapper"
import FormsFilesHeader from "../FormsFilesHeader";
import { useNavigate } from "react-router-dom";

const FormsLibraryEstateView = (): JSX.Element => {
  const navigate = useNavigate();
  const { user, activeEstate, formTypes, languages } = useAuthContext()

  const { state: locationState } = useLocation();
  // Cast Location state to QueryPayload
  const initQueryParams = locationState as QueryPayload;

  const [forms, setForms] = useState<AtticusForm[] | undefined>(undefined);
  const [loadingForms, setLoadingForms] = useState(false);

  const hasAccess = !user?.advisorGroup?.formsDisabled;

  const getForms = async (queryPayload: QueryPayload): Promise<void> => {
    setLoadingForms(true);
    const newForms = await formsApi.fetchForms(queryPayload);

    // Temporary filtering of only English and French forms until we touch
    // FormsLibrarySearch again (county-wide feature expansion for example).
    // Ideal solution is to add a "Language" dropdown to the
    // FormsLibrarySearch component.

    const allowedLanguages = ["en", "fr"];

    const filteredForms = newForms?.filter(
      (form) =>
        (form.language?.code &&
          allowedLanguages.includes(form.language?.code)) ||
        null
    );

    if (filteredForms) {
      setForms(filteredForms);
    }

    // End Temporary

    setLoadingForms(false);
  };

  useEffect(() => {
    if (initQueryParams) {
      getForms(initQueryParams as QueryPayload);
    }
  }, [initQueryParams]);

  return hasAccess ? (
    <div data-automation-id="page-content-estate-forms-library">
      {activeEstate && (
        <>
          <FormsFilesHeader
            title="Atticus Forms Library"
            description="Looking for other forms? Search our Forms Library to find or use more than 3,500 forms. Start by searching for a form, choosing a location, or both:"
            backButtonOptions={{
              text: "Back to My Forms",
              onClick: () => {
                navigate(`${location.pathname}/../`);
              },
            }}
          />
          <Box mt={3} mb={3}>
            <FormsLibrarySearch
              hideHeader
              initGeographyType={
                initQueryParams.geography_type && initQueryParams?.geography_id
                  ? initQueryParams?.geography_type
                  : GeographyType.State
              }
              initGeographyId={
                initQueryParams?.geography_type && initQueryParams?.geography_id
                  ? initQueryParams?.geography_id
                  : activeEstate.stateId
              }
              geographyInclusive={initQueryParams?.geography_inclusive}
              initLanguageCode={
                languages?.find(
                  (lang) => lang.id === initQueryParams?.language_id
                )?.code
              }
              initFormTypeSlug={
                formTypes?.find((ft) => ft.id === initQueryParams?.form_type_id)
                  ?.slug
              }
              initSearchTerms={initQueryParams?.search_terms}
              onComplete={getForms}
              loadingForms={loadingForms}
            />
          </Box>
          <Box>
            <FormsList
              forms={forms}
              estate={activeEstate}
              emptyState={<FormsListZeroState />}
              allowCheckedBadge
            />
          </Box>
        </>
      )}
    </div>
  ) : (
    <></>
  );
};

export default FormsLibraryEstateView;
